import i18next from 'i18next';
import React from 'react';
import styled from 'styled-components';
import { capitalize } from '../../../../../../helpers/StringHelper';
import { colors } from '../riskEvolution';

const Style = styled.div`
  display: flex;
  margin-top: 41px;
  margin-bottom: 34px;

  .desc-group {
    flex: 1;
    border-right: 1px solid #E7E7E7;
    padding: 10px 0px;

    h1 {
      text-align: center;
      margin-bottom: var(--size);
      font-size: 18px;
      font-weight: 600;
    }

    .levels {
      display: flex;
      justify-content: center;
      gap: 4px;
      margin-bottom: var(--size);
    }

    p {
      font-size: 15px;
      color: #616161;
      margin-bottom: 0px;
    }

    &:nth-child(1) {
      padding-right: 17px;
    }

    &:nth-child(2) {
      padding: 10px 17px;
    }

    &:nth-child(3) {
      padding-left: 17px;
      border-right: 0px;
    }
  }
`;

export default function Description({
  data = {}
}) {
  return (data.descriptions && data.assessment) ? (
    <Style>
      {Object.entries(data.descriptions).map(([k, v]) => (
        <div className="desc-group" key={`desc-${k}`}>
          <h1>{i18next.t(capitalize(k))}</h1>
          <div className="levels">
            {[4, 3, 2, 1, 0].map((index) => (
              <svg
                key={index}
                width="11"
                height="11"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 4L6 7.4641L2 7.4641L-1.74846e-07 4L2 0.535898L6 0.535898L8 4Z"
                  fill={(index + 1) <= data.assessment[k] ? colors[data.assessment[k]] : '#f3f3f3'}
                />
              </svg>
            ))}
          </div>
          <p>{v.label}</p>
        </div>
      ))}
    </Style>
  ) : null;
}
